import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import classNames from 'classnames';

// constants
import { MenuItemTypes } from '../../constants/menu';

// components
import Scrollbar from '../../components/Scrollbar';
import FeatherIcons from 'feather-icons-react';
import { Button, Checkbox, Collapse, Dropdown, Modal, Radio, Select, SelectProps, Space } from 'antd';
import ChartMenuDialog from './ChartMenuDialog';
import { useDeleteMenuQuery } from '../../frameWork/rest/menu';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import { defaultEmptyGuid } from '../../constants/defaultValues';
import FilterGeneratorDialog from './FilterGeneratorDialog';
import { CloseCircleFilled, DeleteOutlined, MinusSquareOutlined, PlusSquareOutlined, SettingOutlined } from '@ant-design/icons';
import { TiDeleteOutline } from "react-icons/ti";
import { useAddQuery, useAddQuery2, useDeleteQuery, useGetQuery } from '../../frameWork/rest';
import { FiSettings } from "react-icons/fi";
import FilterMenuEditDialog from './FilterMenuEditDialog';
import { changeChartsAction, changeChartsFilterAction, changeFilterMenuValueAction, changeFlterDeleteAction } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { retLastSegmentURL } from '../../utils/retLastSegmentURL';
import DatePicker, { DateObject, getAllDatesInRange } from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import "react-multi-date-picker/styles/colors/green.css"
import { FaTimes } from 'react-icons/fa';
import DatePickerInput from '../../components/Ant/FloatDatePickerInput/DatePickerInput';
import { persianToLatin } from '../../utils/persianToLatin ';
import { getAllDatesInRange2 } from '../../utils/getAllDatesInRange2';
import moment from 'jalali-moment';
import DatePickerInputForFilter from '../../components/Ant/FloatDatePickerInput/DatePickerInputForFilter';

const DashboardItemDropdown = ({ item }: any) => {
    const [isNewFilterMenuDialog, setIsNewFilterMenuDialog] = useState(false);
    const [isEditFilterMenuDialog, setIsEditFilterMenuDialog] = useState(false);
    const [isDeleteFilterMenuDialog, setIsDeleteFilterMenuDialog] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const handleMenuClick = (e: any) => {
        //message.info('Click on menu item.');        
        // if (e.key === "1") {
        //     setIsNewFilterMenuDialog(true)
        // }

        if (e.key === "1") {
            setIsEditFilterMenuDialog(true)
        }

        if (e.key === "2") {
            Modal.confirm({
                title: "آیا از حذف فیلتر مطمئن هستید؟",
                okText: "بله",
                okType: "danger",
                cancelText: "انصراف",

                onOk() {
                    dispatch(changeFlterDeleteAction({ item: item.id, pageId: retLastSegmentURL(location.pathname) }))
                    setIsDeleteFilterMenuDialog(true)
                }
            })
        }
    };

    const items = [
        // {
        //     label: 'صفحه جدید',
        //     key: '1',
        //     icon: <FeatherIcons className="icon-dual icon-xs" icon={'plus-circle'} />,
        // },
        {
            label: 'تغییر نام',
            key: '1',
            icon: <FeatherIcons className="icon-dual icon-xs" icon={'edit'} />,
        },
        {
            label: 'حذف',
            key: '2',
            icon: <FeatherIcons className="icon-dual icon-xs" icon={'trash-2'} />,
        }
    ]

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };



    return (
        <>
            <Dropdown
                menu={menuProps}
                placement="bottomLeft"
            //trigger={['click']}
            >
                {/* <FeatherIcons style={{ color: 'rgb(164 170 182)' }} className="icon-dual icon-xs settings-menu-arrow" icon={'more-vertical'} /> */}
                <FiSettings style={{ color: 'rgb(143 143 143)' }} fontSize={14} />
            </Dropdown>

            {isEditFilterMenuDialog &&
                <FilterMenuEditDialog
                    modalOpen={isEditFilterMenuDialog}
                    setDialogOpen={() => setIsEditFilterMenuDialog(false)}
                    item={item}
                    isEdit={true}
                />
            }
        </>

    );
};

const FilterItemsDashboard = () => {
    const dispatch = useDispatch();
    const { Panel } = Collapse;
    const location = useLocation();
    const datePickerRef = useRef<any>()
    const { chartList, filterMenuList, config } = useSelector((state: any) => state.DashboardPage, _.isEqual);
    // useEffect(() => {
    //     //getFilterMenu();
    //     //getAllChartList();
    //     //getAllDataSourceList();
    // }, [location])

    // useEffect(() => {
    // }, [FilterMenuList])

    const [isFilterGeneratorDialogOpen, setIsFilterGeneratorDialogOpen] = useState(false);
    const handleFilterGeneratorDialog = () => {
        setIsFilterGeneratorDialogOpen(true)
    }

    const options: SelectProps['options'] = [];

    for (let i = 10; i < 36; i++) {
        options.push({
            value: i.toString(36) + i,
            label: i.toString(36) + i,
        });
    }

    const genExtra = (item: any) => (
        // <FiSettings
        //     fontSize={14}
        //     onClick={() => del()}
        // />
        <DashboardItemDropdown item={item} />
    );
    const del = () => {
        Modal.confirm({
            title: "آیا از حذف فیلتر مطمئن هستید؟",
            okText: "بله",
            okType: "danger",
            cancelText: "انصراف",

            onOk() {
                // deleteMenu(item.id)
                // setIsDeleteFilterMenuDialog(true)
            }
        })
    }




    const RenderType = ({ item }: any) => {
        const CheckboxGroup = Checkbox.Group;

        const { mutateAsync: getCubeByQuerySelectFilter, data: dataFiltering }: any = useAddQuery2(API_ENDPOINTS.CUBE_GET_FILTERQUERY, "");

        const [dataFilter, setDataFilter] = useState<any>([])
        const [dataPickerValue, setDataPickerValue] = useState<any>(item?.value)
        const [isRange, setIsRange] = useState<any>(item?.isRange)

        useEffect(() => {
            const d = async () => {
                await getCubeByQuerySelectFilter(JSON.stringify({ "datasourceId": item.sDataSourceId, "filterCol": item.colName, "newFields": [], start: 0, limit: 200, whereQuery: "" }));
            }
            d()
        }, [])

        useEffect(() => {
            let c = dataFiltering?.map((u: any) => ({ value: u?.filterCol?.toString(), label: u?.filterCol?.toString() }))
            setDataFilter(c)

        }, [dataFiltering])

        const handleChange = (v: any) => {
            console.log('typeof v:',typeof v,v?.target?.value)
            let v0: any;
            if (typeof v === "string")
                v0 = [v]
            else
                if (typeof v === "object") {
                    if (v?.target) {
                        v0 = v.target.value != '' ? [v.target.value] : [];
                    }
                    else {
                        v0 = v
                    }
                }
                console.log('v0:',v0)
            dispatch(changeFilterMenuValueAction({ dataf: { colName: item.colName, value: v0, sDataSourceId: item.sDataSourceId } }))
        }


        const getAllDatesInRange2 = (start: any, end: any) => {
            let dates = [];
            let currentDate = moment(start);

            while (currentDate.isBefore(end) || currentDate.isSame(end)) {
                dates.push(currentDate.clone().format('YYYY/MM/DD'));
                currentDate.add(1, "day");
            }

            return dates;
        };

        const handleChangeDate = (v: any, isRange: boolean) => {
            //setIsRange(isRange)                                                                
            dispatch(changeFilterMenuValueAction({ dataf: { colName: item.colName, value: v, sDataSourceId: item.sDataSourceId, isRange: isRange } }))
            setDataPickerValue(v)
        }

        const handleisRangeChange = (v: boolean) => {
            //setIsRange(v)                                                                
            dispatch(changeFilterMenuValueAction({ dataf: { colName: item.colName, value: [], sDataSourceId: item.sDataSourceId, isRange: v } }))
            setDataPickerValue([])
            //setDataPickerValue(v)            
        }

        const debounceFetcher = async (e: any) => {
            await getCubeByQuerySelectFilter(JSON.stringify({ "datasourceId": item.sDataSourceId, "filterCol": item.colName, "newFields": [], start: 0, limit: 400, whereQuery: e }));
        }

        const debounceSearch = _.debounce(debounceFetcher, 800);

        const handleSearch = (value: any) => {
            if (value) {
                debounceSearch(value);
            } else {
                setDataFilter([]);
            }
        };

        const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
        console.log('dataFilter:',dataFilter,item)

        switch (item.filterType) {
            case 1:
                return (<Select
                    size={'small'}
                    //defaultValue="a1"
                    value={item.value}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                    options={dataFilter}
                    onSearch={handleSearch}
                    allowClear
                    showSearch
                />)

            case 2:
                return (<Select
                    mode="multiple"
                    size={'small'}
                    //defaultValue="a1"
                    value={item.value === "" ? [] : item.value}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                    options={dataFilter}
                    onSearch={handleSearch}
                    allowClear
                />)

            case 3:
                let cc: any = [];
                if (dataFilter)
                    cc = [...dataFilter, { value: "", label: "---" }]
                return (
                    <Radio.Group
                        size="small"
                        options={cc}
                        onChange={handleChange}
                        value={item?.value?.length > 0 ? item.value[0] : ""} />
                )

            case 4:
                return (
                    <CheckboxGroup
                        style={{ display: 'flex', flexDirection: 'column' }}
                        options={dataFilter}
                        value={item.value}
                        onChange={handleChange} />

                )

            case 5:
                return (
                    <DatePickerInputForFilter
                        AzTarixValue={dataPickerValue && dataPickerValue.length > 0 ? dataPickerValue[0] : item?.value?.length > 0 ? item?.value[0] : ""}
                        handleChangeTarix={handleChangeDate}
                        TaTarixValue={dataPickerValue && dataPickerValue.length > 0 ? dataPickerValue[1] : item?.value?.length > 0 ? item?.value[1] : ""}
                        //  handleChangeTaTarix={handleChangeDate}
                        isRangeState={item?.isRange}
                        onei={handleisRangeChange}
                    />

                    // <DatePickerInput
                    // value={dataPickerValue && dataPickerValue.length > 0 ? dataPickerValue?.length > 0 ? dataPickerValue?.length > 1 ? dataPickerValue : dataPickerValue[0] : "" : item?.value?.length > 0 ? item?.value?.length > 1 ? item?.value : item?.value[0] : ""}
                    //  one={handleChangeDate}
                    //  isRange={true}                    
                    //  />

                    // <div className="date-picker-container">
                    //     <DatePicker
                    //         onOpenPickNewDate={false}
                    //         onClose={() => false}
                    //         ref={datePickerRef}
                    //         portal
                    //         //portalTarget={portalTarget}
                    //         //layout="mobile"
                    //         style={{ width: '100%', height: 24 }}
                    //         containerStyle={{ width: '100%' }}
                    //         value={dataPickerValue && dataPickerValue.length > 0 ? dataPickerValue?.length > 0 ? dataPickerValue?.length > 1 ? dataPickerValue : dataPickerValue[0] : "" : item?.value?.length > 0 ? item?.value?.length > 1 ? item?.value : item?.value[0] : ""} onChange={(e) => handleChangeDate(e, true)}
                    //         calendar={persian}
                    //         locale={persian_fa}
                    //         calendarPosition="left"
                    //         //className="rmdp-mobile"
                    //         //className="green"
                    //         weekDays={weekDays}
                    //         className="green"
                    //         range
                    //         dateSeparator=" تا "
                    //     >
                    //         <div>
                    //             <Button
                    //                 style={{ marginBottom: 5 }}
                    //                 //type='link'
                    //                 onClick={() => onHandleCloseDatePicker(dataPickerValue)}
                    //             >
                    //                 تائید
                    //             </Button>                                
                    //         </div>
                    //     </DatePicker>
                    //     {dataPickerValue.length > 0 || item?.value?.length > 0 && (
                    //         <CloseCircleFilled
                    //         className="clear-icon"
                    //             onClick={clearDate}                                
                    //         />
                    //     )}
                    // </div>
                )


            default:
                return (<Select
                    mode="multiple"
                    size={'small'}
                    //defaultValue="a1"
                    value={item.value === "" ? [] : item.value}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                    options={dataFilter}
                    allowClear
                />)

        }
    }

    const FilterGen = ({ item }: any) => {
        return (
            <Collapse expandIcon={({ isActive }) => isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />} style={{ borderRadius: 5 }} defaultActiveKey={[item.id]}>
                <Panel className="custom-collapse-header" header={item.title} key={item.id} extra={genExtra(item)}>
                    {/* {renderType(item)} */}
                    <RenderType key={item?.id} item={item} />
                    {/* <Select
                        mode="multiple"
                        size={'small'}
                        defaultValue="a1"
                        //onChange={handleChange}
                        style={{ width: '100%' }}
                        options={options}
                    /> */}
                </Panel>
            </Collapse>
        )
    }

    return (
        <>
            <div className="sidebar-main-menu" >
                <div id="two-col-menu" className="h-100" style={{ margin: '5px 5px 0px 15px' }}>
                    {location.pathname.indexOf('/dashboard/publicdashboardPage') === -1 && <div>
                        <Button style={{ marginBottom: 5, borderRadius: 5, width: '100%' }} onClick={() => handleFilterGeneratorDialog()}>
                            افزودن فیلتر
                        </Button>
                    </div>
                    }
                    <Scrollbar style={{ maxHeight: '100%' }}>
                        <Space style={{ width: '100%' }} direction="vertical">
                            {filterMenuList && filterMenuList?.length > 0 ? filterMenuList?.map((f: any) => (
                                <FilterGen key={f.id} item={f} />
                            )) :
                                <React.Fragment>
                                    <div style={{ textAlign: 'center' }} className="alert alert-info" role="alert">
                                        فیلتری تعریف نشده است
                                    </div>
                                </React.Fragment>
                            }
                            {/* <Collapse expandIcon={({ isActive }) => isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />} style={{ borderRadius: 5 }} expandIconPosition="end" defaultActiveKey={['1']}>
                                <Panel header="گروه شکلی" key="1" extra={genExtra()}>
                                    <Select
                                        mode="multiple"
                                        size={'small'}
                                        defaultValue="a1"
                                        //onChange={handleChange}
                                        style={{ width: '100%' }}
                                        options={options}
                                    />
                                </Panel>
                            </Collapse>
                            <Collapse expandIcon={({ isActive }) => isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />} style={{ borderRadius: 5 }} expandIconPosition="end" defaultActiveKey={['1']}>
                                <Panel header="وضعیت قرارداد" key="1" extra={genExtra()}>
                                    <Radio.Group size="small" value={'large'} >
                                        <Radio.Button value="large">Large</Radio.Button>
                                        <Radio.Button value="middle">Default</Radio.Button>
                                        <Radio.Button value="small">Small</Radio.Button>
                                    </Radio.Group>
                                </Panel>
                            </Collapse>
                            <Collapse expandIcon={({ isActive }) => isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />} style={{ borderRadius: 5 }} expandIconPosition="end" defaultActiveKey={['1']}>
                                <Panel header="نوع محصول" key="1" extra={genExtra()}>
                                    <Select
                                        size={'small'}
                                        defaultValue="a1"
                                        //onChange={handleChange}
                                        style={{ width: '100%' }}
                                        options={options}
                                    />
                                </Panel>
                            </Collapse> */}

                        </Space>
                        {/* <ul className="nav flex-column">
                            <React.Fragment>
                                <Space direction="vertical" >
                                    <Select
                                    mode="multiple"
                                        size={'small'}
                                        defaultValue="a1"
                                        //onChange={handleChange}
                                        style={{ width: '100%' }}
                                        options={options}
                                    />
                                </Space>
                            </React.Fragment>
                            <React.Fragment>
                                <li>
                                    <Radio.Group size="small" value={'large'} >
                                        <Radio.Button value="large">Large</Radio.Button>
                                        <Radio.Button value="middle">Default</Radio.Button>
                                        <Radio.Button value="small">Small</Radio.Button>
                                    </Radio.Group>
                                </li>
                            </React.Fragment>
                            <React.Fragment>
                                <li>
                                    <div style={{ textAlign: 'center' }} className="alert alert-info" role="alert">
                                        فیلتری تعریف نشده است
                                    </div>
                                </li>
                            </React.Fragment>
                        </ul> */}
                    </Scrollbar>
                </div>
                {/* <div style={{ margin: 10, marginTop:0 }}>
                    <Button style={{ marginTop: 5, borderRadius: 5, width: '100%' }} onClick={() => handleFilterGeneratorDialog()}>
                        افزودن فیلتر
                    </Button>
                </div> */}
            </div>

            {isFilterGeneratorDialogOpen &&
                <FilterGeneratorDialog
                    modalOpen={isFilterGeneratorDialogOpen}
                    setDialogOpen={() => setIsFilterGeneratorDialogOpen(false)}
                //item={retLastSegmentURL(location.pathname)}
                />
            }
        </>
    );
};

export default React.memo(FilterItemsDashboard);
